import React from 'react';
import { DisabledCamera } from './disabled-camera';
import { EnabledCamera } from './enabled-camera';
export const Camera = ({ disabled }) => {
    return (<>
      {disabled && <DisabledCamera />}
      {!disabled && <EnabledCamera />}
    </>);
};
